<template>

    <div class="mt-10 d-flex align-center pointer gap-6 text-15 weight-600 opacity-60" @click="goBackToLogin">
        <left-arrow></left-arrow> Back to log in
    </div>

</template>



<script setup>

import { inject } from 'vue';
import authEvents from '@/Events/AuthDialog';
import LeftArrow from "@/icons/LeftArrow.vue";


const dialogVisible = inject('openDialog');


const goBackToLogin = () => {
    authEvents.emit('open-auth-dialog');
    closeForgotPasswordDialog();
};

const closeForgotPasswordDialog = () => {
    dialogVisible.value = false;
}

</script>